import { createFileRoute } from '@tanstack/react-router';

import { getGovernanceQueryOptions } from '@/_pages/governance/api-service';
import Loading from '@/_pages/governance/profile/loading';

export const Route = createFileRoute('/_private/governance/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getGovernanceQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
